import EventBase from './EventBase'
import EventID from './EventID'
import {
    ensureAudioFadeParameters,
    readAudioFadeSeconds,
    readAudioFadeTrack,
    writeAudioFadeSeconds,
    writeAudioFadeTrack,
} from './audioEventShared'

/**
 * 506  -  停止音效
 */

export default class EventStopSE extends EventBase {
    /**
     * 构造函数
     */
    constructor() {
        super()
        this.Parameter = ensureAudioFadeParameters(['0', '', '0'])
    }

    /**
     * 事件ID
     */
    Code = EventID.StopSE

    get Time() {
        return readAudioFadeSeconds(this.Parameter)
    }
    set Time(val: number) {
        this.Parameter = writeAudioFadeSeconds(this.Parameter, val)
    }

    get Description() {
        return this.Parameter?.[1] ?? ''
    }
    set Description(value) {
        this.Parameter = ensureAudioFadeParameters(this.Parameter)
        this.Parameter[1] = value.toString()
    }

    get AudioIndex() {
        return readAudioFadeTrack(this.Parameter)
    }
    set AudioIndex(value) {
        this.Parameter = writeAudioFadeTrack(this.Parameter, value)
    }

    /**
     * 获得该事件在事件列表的描述信息
     */
    /// <returns>事件描述信息</returns>
}
